import _ from 'lodash'
import { CellDefaultWidth } from './config'
import getScrollbarWidth from '../../core/utils/KScrollbarWidth'

/**
 * 组件统一布局管理
 */
export default {
  data() {
    return {
      context: null,
      containerWidth: 0,
      scrollLeft: 0,
      // scrollbarSize: getScrollbarWidth(),
      nativeScrollbarSize: getScrollbarWidth(),
      headerAffixed: false,
      footerAffixed: false,
      lockScroll: false,
    }
  },
  computed: {
    ready() {
      return this.context && this.context.mounted
    },
    store() {
      return this.ready && this.context.store
    },
    columns() {
      return (this.ready && _.filter(this.store.columns || [], col => col.visible))
    },
    innerContainerWidth() { // width exclude scrollbar
      return this.containerWidth
    },
    centerColumns() { // 过滤掉左右固定的列
      return _.filter(this.columns, (column) => !column.fixed)
    },
    flexibleColumns() { // 过滤掉固定宽度的列
      return _.filter(this.columns, (column) => !column.fixedWidth)
    },
    fixedWidthColumns() {
      return _.filter(this.columns, (column) => column.fixedWidth)
    },
    leftFixedColumns() {
      return _.filter(this.columns, (column) => column.fixed && column.fixed !== 'right')
    },
    rightFixedColumns() {
      return _.filter(this.columns, (column) => column.fixed === 'right')
    },
    totalFlexibleWidth() {
      return _.sumBy(this.flexibleColumns, (column) => column.width || CellDefaultWidth)
    },
    totalFixedWidth() {
      return _.sumBy(this.fixedWidthColumns, (column) => column.width || CellDefaultWidth)
    },
    flexibleGap() {
      // 容器宽度与所有列宽度之和的差值，正值则说明列宽总和小于容器宽度 -> 每个 column 会根据该值调整自己的宽度
      return this.innerContainerWidth - this.totalFixedWidth - this.totalFlexibleWidth
    },
    renderLeftWidth() {
      return _.sumBy(this.leftFixedColumns, (column) => column.realWidth)
    },
    renderRightWidth() {
      return _.sumBy(this.rightFixedColumns, (column) => column.realWidth)
    },
    renderCenterWidth() {
      return _.sumBy(this.centerColumns, (column) => column.realWidth)
    },
    centerViewWidth() {
      return this.innerContainerWidth - this.renderLeftWidth - this.renderRightWidth
    },
  },
  watch: {
    columns() {
      console.log('columns updatted....................')
      this.updateLayout()
    },
  },
  created() {
  },
  methods: {
    // native scroll
    apiHandleHeaderScroll: _.throttle(function () {
      if (this.lockScroll) {
        return
      }
      // console.log('apiHandleHeaderScroll')

      const header = this.context.$refs.header.$refs.scrollContainer
      this.scrollLeft = header.scrollLeft
      // this.context.$refs.body.$refs.scrollContainer.scrollLeft = this.scrollLeft
      // this.context.$refs.body.$refs.scrollBody.setScrollLeft(this.scrollLeft)
      if (this.context.$refs.rowFooter) {
        this.context.$refs.rowFooter.$refs.scrollContainer.scrollLeft = this.scrollLeft
      }
    }, 10),
    // scroll bar scroll event
    apiHandleBodyScroll: _.throttle(function (scrollInfo) {
      const { scrollLeft } = scrollInfo

      this.scrollLeft = scrollLeft

      // console.log('scrollLeft: ', scrollLeft)
      // {
      //   scrollTop,
      //     scrollLeft,
      //     scrollHeight: wrap.scrollHeight,
      //   height: wrap.clientHeight,
      //   width: wrap.clientWidth,
      // }
      // scrollTop,
      //   scrollLeft,
      //   scrollHeight: wrap.scrollHeight,
      //   height: wrap.clientHeight,
      //   width: wrap.clientWidth,

      // const body = this.context.$refs.body.$refs.scrollContainer
      // this.scrollLeft = body.scrollLeft
      this.lockScroll = true
      this.context.$refs.header.$refs.scrollContainer.scrollLeft = scrollLeft
      if (this.context.$refs.rowFooter) {
        this.context.$refs.rowFooter.$refs.scrollContainer.scrollLeft = scrollLeft
      }

      this.$nextTick(() => {
        this.lockScroll = false
      })
    }, 10),
    // native scroll
    apiHandleRowFooterScroll: _.throttle(function () {
      console.log('apiHandleRowFooterScroll')
      const rowFooter = this.context.$refs.body.$refs.scrollContainer
      this.scrollLeft = rowFooter.scrollLeft
      this.context.$refs.header.$refs.scrollContainer.scrollLeft = this.scrollLeft
      // this.context.$refs.body.$refs.scrollContainer.scrollLeft = this.scrollLeft
      // this.context.$refs.body.$refs.scrollBody.setScrollLeft(this.scrollLeft)
    }, 10),
    apiHandleResize({ width }) {
      this.containerWidth = width
    },
    updateLayout() {
      this.containerWidth = this.context.$el.offsetWidth
    },
  },
}
